// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.Sample = M.View.Sample || {};

/**
 * @class M.View.Sample.SampleDialog
 *
 */
M.View.Sample.ColorChoice = Backbone.View.extend({

  events: {
    'click .cancelButton': 'cancel',
    'click .saveButton': 'save',
    'click .removeButton': 'remove'
  },

  initialize: function() {
    this.$el = $(this.el);

    var templateHtml = M.Template.Sample.ColorChoice;
    this.template = _.template(templateHtml);
  },

  render: function() {
    this.$el.html(this.template({
      isCustomColor: this.model.get('isCustomColor'),
      colorDescription: this.model.get('colorDescription'),
      howToUseColor: this.model.get('howToUseColor'),
      additionalInstructions: this.model.get('additionalInstructions'),
      isExistingChoice: this.options.isExistingChoice
    }));

    this.$el.dialog({
      modal: false,
      draggable: false,
      width: 540,
      title: ' ' + this.model.get('colorName'),
      dialogClass: 'colorChoiceDialog'
    });

    var dialogTitle = this.$('.ui-dialog-title');
    dialogTitle.wrapInner(
      '<div class="floatL" style="line-height:40px;"></div>');
    if (!this.model.get('isCustomColor')) {
      dialogTitle.prepend('<div class="floatL" style="background-color:#' +
        this.model.get('rgb') + ';width:40px;height:40px;"></div>');
    }

    this.selectCheckBoxes();

    return this.$el;
  },

  /**
   * Re-select any checkboxes that may have been previously selected
   */
  selectCheckBoxes: function() {
    var that = this;
    this.$el.find('ul.inputs li input').each(function () {
      if (that.model.get('howToUseColor').indexOf($(this).val()) > -1) {
        $(this).attr('checked', 'true');
      }
    });

  },

  cancel: function() {
    this.$el.dialog('close');
  },

  save: function() {
    this.$el.find('.warning').hide();
    var howToUseColor = ''
    this.$el.find('ul.inputs li input').each(function () {
      if ($(this).is(':checked')) {
        howToUseColor += $(this).val() + ',';
      }
    });

    // validate inputs
    if (howToUseColor === '') {
      this.$el.find('.warning.color').show();
    }
    if (this.model.get('isCustomColor') &&
      this.$el.find('#colorDescription').val() === '') {
        this.$el.find('.warning.description').show();
    }
    if (this.$el.find('.warning:visible').length > 0) {
      return false;
    }

    this.model.set({
      colorDescription: this.$el.find('#colorDescription').val(),
      howToUseColor: howToUseColor,
      additionalInstructions: this.$el.find('#additionalInstructions').val()
    });
    this.trigger('saveColor', this.model);
    this.$el.dialog('close');
  },

  remove: function() {
    this.trigger('removeColor', this.model);
    this.$el.dialog('close');
  }


});
